import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { TableCardList } from '@/components/ui/table-card'
import { DocumentCards } from './DocumentCards'
import { DocumentRows } from './DocumentRow'
import type { DocumentsTableDocument } from './types'
import { useDocumentRowActions } from './useDocumentRowActions'

export const DOCUMENTS_TABLE_HEADER = (
  <TableHeader>
    <TableRow className="[&>th]:py-2">
      <TableHead className="font-semibold">Name</TableHead>
      <TableHead className="font-semibold">Type</TableHead>
      <TableHead className="font-semibold">Effective</TableHead>
      <TableHead className="font-semibold">Expires</TableHead>
      <TableHead className="font-semibold">Size</TableHead>
      <TableHead className="font-semibold">Uploaded</TableHead>
      <TableHead className="w-px" />
    </TableRow>
  </TableHeader>
)

export const NO_DOCUMENTS = <p className="text-muted-foreground text-sm">No documents found.</p>

/** `readonly` drops rename, the only mutating row control; Details stays. */
export function DocumentsTable({
  documents,
  readonly,
}: {
  documents: DocumentsTableDocument[]
  readonly?: boolean
}) {
  const { openDetails, openRename, dialogs } = useDocumentRowActions()
  const rename = readonly ? undefined : openRename

  if (documents.length === 0) return NO_DOCUMENTS

  return (
    <>
      <TableCardList className="xl:hidden">
        <DocumentCards documents={documents} openDetails={openDetails} openRename={rename} />
      </TableCardList>

      <div className="hidden xl:block">
        <Table>
          {DOCUMENTS_TABLE_HEADER}
          <TableBody>
            <DocumentRows documents={documents} openDetails={openDetails} openRename={rename} />
          </TableBody>
        </Table>
      </div>
      {dialogs}
    </>
  )
}
